<template>
  <div class="mapContent d-flex flex-column">
    <div class="info">
      <!-- <div class="block">
        <div class="item">
          <p class="m-0 mb-3 text-center colorWhite">No. of startups</p>
          <p class="m-0 number text-center colorWhite">{{startup.length}}</p>
        </div>
        <div class="item">
          <p class="m-0 mb-3 text-center colorWhite">MOIC*</p>
          <p class="m-0 mb-3 number text-center colorWhite">{{moic.value}}</p>
          <p class="m-0 text-center colorWhite caption" style="line-height: normal">
            {{moic.text}}
          </p>
        </div>
        <div class="item">
          <p class="m-0 mb-3 text-center colorWhite">Gross IRR**</p>
          <p class="m-0 mb-3 number text-center colorWhite">{{gross_irr.value}}%</p>
          <p class="m-0 text-center colorWhite caption">{{gross_irr.text}}</p>
        </div>
        <div class="item">
          <p class="m-0 mb-3 text-center colorWhite">Board Positions</p>
          <p class="m-0 mb-3 number text-center colorWhite">{{board_positions.value}}</p>
        </div>
      </div>
      <div class="item hasChart" style="flex: 1">
        <div id="regionchart" class="m-0 number text-center colorWhite"></div>
      </div>
      <div class="item hasChart" style="flex: 1">
        <div id="stagechart" class="m-0 number text-center colorWhite"></div>
      </div> -->
      <div class="block newValue text-white">
        <div class="item d-flex" v-for="(item, index) in newValue" :key="index">
          <div class="f mr-2" :style="{ 'background-color': item.color }">
            {{ item.name }}
          </div>
          <div class="value">
            <p class="mb-2 mt-1">
              <strong>{{ item.title }}</strong>
            </p>
            <p class="mb-2">{{ item.vintage }}</p>
            <p class="mb-2">{{ item.size }}</p>
            <p class="mb-0">{{ item.comps }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="map-container d-flex justify-content-center">
      <div class="overlay"></div>
      <LpMap class="lpmap"/>
    </div>
    <div class="legend d-flex justify-content-center align-items-center">
      <div class="legend-item d-flex">
        <svg version="1.1" class="legend-icon"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink" role="group">
          <g fill="#e342f5" focusable="false" tabindex="-1" fill-opacity="1">
            <g shape-rendering="auto">
              <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" />
            </g>
          </g>
        </svg>
        <label class="legend-title">Headquarters</label>
      </div>
      <div class="legend-item d-flex">
        <svg version="1.1" class="legend-icon"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink" role="group">
          <circle r="8" cx="11" cy="12" fill="#4397f8" />
        </svg>
        <label class="legend-title">Satellite Offices</label>
      </div>
      <div class="legend-item d-flex">
        <svg version="1.1" class="legend-icon"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink" role="group">
          <rect width="20" height="20" x="0" y="2" fill="#01467a" />
        </svg>
        <label class="legend-title">Portfolio Companies</label>
      </div>
    </div>
  </div>
</template>

<script src="./index.js"></script>

<style lang="scss" scoped>
.mapContent {
  background-color: #1e2128;
  height: 100%;
  font-family: "SF Pro Text";
  .info {
    display: flex;
    height: 125px;
    @media screen and (max-width: 1023.98px) {
      height: 230px;
    }
    @media screen and (max-width: 568px) {
      height: 410px;
    }
    // @media screen and (max-width: 480px) {
    //   display: block;
    // }
    .block {
      flex: 0 0 40%;
      display: flex;
      @media screen and (max-width: 992px) {
        display: block;
        flex: 0 0 33%;
      }
      @media screen and (max-width: 480px) {
        display: flex;
      }

      > div {
        flex: 1;
      }
      .item {
        padding: 15px 0 0 0;
        @media screen and (max-width: 1023.98px) {
          padding: 8px 0px;
        }
      }
    }
    #regionchart,
    #stagechart {
      display: block;
      width: 100%;
      height: 100%;
    }
    .item {
      padding: 15px;
      @media screen and (max-width: 1023.98px) {
        padding: 8px;
      }
      &.hasChart {
        @media screen and (max-width: 480px) {
          height: 100px;
        }
      }
      p {
      }
      .number {
        font-size: 35px;
        @media screen and (max-width: 992px) {
          font-size: 35px;
        }
        @media screen and (max-width: 480px) {
          font-size: 26px;
        }
      }
      .caption {
        font-size: 10px;
      }
    }
    .newValue {
      flex: 1;
      &.block {
        display: flex;
        flex-wrap: wrap;
      }
      .item {
        flex: 1;
        @media screen and (max-width: 1023.98px) {
          flex: 0 0 50%;
          max-width: 50%;
        }
        @media screen and (max-width: 568px) {
          flex: 0 0 100%;
          max-width: 100%;
        }
        .f {
          flex: 0 0 75px;
          height: 90px;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 22px;
          font-weight: bold;
        }
        .value {
          flex: auto;
          margin-left: 10px;

          p {
            font-size: 13px;
            line-height: 14px;
            @media screen and (min-width: 568px) {
              font-size: 14px;
              font-weight: 500;
            }
          }

          strong {
            font-size: 20px;
            font-weight: 600;
          }
        }
      }
    }
  }
  .map-container {
    position: relative;
    flex-grow: 1;

    .overlay {
      width: 100%;
      height: 100%;
      position: absolute;
    }
    .lpmap {
      width: 90%;
      height: 90%;
    }
  }
  .legend {
    min-height: 40px;
    
    .legend-item {
    }
    .legend-icon {
      width: 22px;
      height: 22px;
      margin-right: 5px;
    }
    .legend-title {
      color: #fff;
      margin-right: 15px;
    }
  }

  #mapchart {
    width: 100%;
    height: calc(100vh - 140px - 65px);
    padding: 10px;
    @media screen and (max-width: 1023.98px) {
      height: calc(100vh - 230px);
      // padding-bottom: 75px;
    }
    @media screen and (max-width: 568px) {
      height: calc(100vh - 410px);
    }
  }
}
</style>
